var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-manageable-combo',_vm._g(_vm._b({attrs:{"method-create":_vm.methodCreate,"method-update":_vm.methodUpdate,"method-list":_vm.methodList,"form-schema":_vm.schema,"value":_vm.value,"entity-name":"Тег","entity-name-plural":"Теги","entity-name-upsert":"Тега","clearable":""}},'dv-manageable-combo',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }